import { deepJSONParse } from '../../utils/functions.utils.ts'
import { isWeb } from '../../utils/platformUtils'
import { LEARNING_STORE_NAMES } from '../constants'
// Eliminado import directo de expo-sqlite: ahora dependemos de que el caller proporcione db (adapter)

// Exportar LEARNING_STORE_NAMES para uso en componentes
export { LEARNING_STORE_NAMES }

const dbName = 'myDB'
const versionsStoreName = 'versions'

import { openDB } from '../indexDB'

// crear fn para guardar cursos, contenidos, evaluaciones y categorias
// cada vez que haga el fetch a la base y revisar que mi version sea distinta, debo guardar todo
// o sea llamar a una funcion que me ejecute las funciones de guardado de cursos, contenidos evaluaciones y categorias
// armar un endpoint que me junte todo o sea me traiga categories, dentro cursos, contenidos y evaluaciones

export const update_data_version = async (db, courses, contents, evaluations, categorys) => {
    try {
        if (courses.length > 0) {
            for (const course of courses) {
                await add_course(db, course)
            }
        }

        if (contents.length > 0) {
            for (const content of contents) {
                await add_content(db, content)
            }
        }

        if (categorys.length > 0) {
            for (const category of categorys) {
                await add_category(db, category)
            }
        }

        if (evaluations.length > 0) {
            for (const evaluation of evaluations) {
                await add_evaluation(db, evaluation)
            }
        }

        // update_data_version completed
    } catch (error) {
        console.error('Error al obtener registros:', error)
        throw new Error('Error al obtener registros en update_data_version')
    }
}

export const get_learning = async (db) => {
    try {
        const [courses, contents, categories, evaluations] = await Promise.all([
            get_courses(db),
            get_contents(db),
            get_categories(db),
            get_evaluations(db),
        ])
        return { courses, contents, categories, evaluations }
    } catch (error) {
        console.error('Error al obtener datos:', error)
        throw new Error('Error al obtener datos:')
    }
}

//* cursos
export const add_course = (db, course) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const transaction = db.transaction([LEARNING_STORE_NAMES.COURSES], 'readwrite')
            const objectStore = transaction.objectStore(LEARNING_STORE_NAMES.COURSES)

            const request = objectStore.add(course)

            request.onsuccess = () => {
                resolve()
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            try {
                // Check if course exists
                const checkStatement = db.prepareSync(`SELECT COUNT(*) as count FROM ${LEARNING_STORE_NAMES.COURSES} WHERE _id = ?`)
                const first = checkStatement.getFirstSync([course._id])
                const count = first?.count ?? 0
                checkStatement.finalizeSync()

                if (count === 0) {
                    // Insert new course
                    const insertStatement = db.prepareSync(`INSERT INTO ${LEARNING_STORE_NAMES.COURSES} (
                        _id, blocked_by, date, title, cover_image, description_short, description_long,
                        share, progressive_mode, likes, evaluations, type, moduls, status_liked, status,
                        category_id, course_index, certificate, download_zip
                    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`)

                    insertStatement.executeSync([
                        course._id,
                        JSON.stringify(course.blocked_by),
                        course.date,
                        course.title,
                        course.cover_image,
                        course.description_short,
                        course.description_long,
                        course.share,
                        course.progressive_mode,
                        course.likes,
                        JSON.stringify(course.evaluations),
                        JSON.stringify(course.type),
                        JSON.stringify(course.moduls),
                        course.status_liked,
                        course.status,
                        course.category_id,
                        course.course_index,
                        course.certificate,
                        course.download_zip,
                    ])

                    insertStatement.finalizeSync()
                }

                resolve()
            } catch (error) {
                console.error('Error in add_course:', error)
                reject(error)
            }
        }
    })
}

const get_courses = (db) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const transaction = db.transaction([LEARNING_STORE_NAMES.COURSES], 'readonly')
            const objectStore = transaction.objectStore(LEARNING_STORE_NAMES.COURSES)
            const request = objectStore.getAll()

            request.onsuccess = (event) => {
                const courses = event.target.result
                resolve(courses)
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            try {
                // Debug logs removed

                const statement = db.prepareSync(`SELECT * FROM ${LEARNING_STORE_NAMES.COURSES}`)
                const courses = statement.getAllSync()
                statement.finalizeSync()

                const modifiedCourses = courses.map((course) => {
                    return {
                        ...course,
                        blocked_by: JSON.parse(course.blocked_by || '[]'),
                        evaluations: JSON.parse(course.evaluations || '[]'),
                        type: JSON.parse(course.type || '[]'),
                        moduls: JSON.parse(course.moduls || '[]'),
                    }
                })

                resolve(modifiedCourses)
            } catch (error) {
                console.error('Error in get_courses:', error)
                reject(error)
            }
        }
    })
}

// Contents implementation
export const add_content = (db, content) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const transaction = db.transaction([LEARNING_STORE_NAMES.CONTENTS], 'readwrite')
            const objectStore = transaction.objectStore(LEARNING_STORE_NAMES.CONTENTS)

            const request = objectStore.add(content)

            request.onsuccess = () => {
                resolve()
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            try {
                // Check if content exists
                const checkStatement = db.prepareSync(`SELECT COUNT(*) as count FROM ${LEARNING_STORE_NAMES.CONTENTS} WHERE _id = ?`)
                const first = checkStatement.getFirstSync([content._id])
                const count = first?.count ?? 0
                checkStatement.finalizeSync()

                if (count === 0) {
                    // Insert new content
                    const insertStatement = db.prepareSync(`INSERT INTO ${LEARNING_STORE_NAMES.CONTENTS} (
                        _id, evaluations, course_name, media, content_type, title, description_short,
                        description_long, media_slides, link_share, status, cover_image, certificate
                    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`)

                    insertStatement.executeSync([
                        content._id,
                        typeof content.evaluations === 'string' ? content.evaluations : JSON.stringify(content.evaluations || []),
                        content.course_name,
                        content.media,
                        content.content_type,
                        content.title,
                        content.description_short,
                        content.description_long,
                        typeof content.media_slides === 'string' ? content.media_slides : JSON.stringify(content.media_slides || []),
                        content.link_share,
                        content.status,
                        content.cover_image,
                        typeof content.certificate === 'string' ? content.certificate : JSON.stringify(content.certificate || null),
                    ])

                    insertStatement.finalizeSync()
                }

                resolve()
            } catch (error) {
                console.error('Error in add_content:', error)
                reject(error)
            }
        }
    })
}

export const get_contents = (db) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const transaction = db.transaction([LEARNING_STORE_NAMES.CONTENTS], 'readonly')
            const objectStore = transaction.objectStore(LEARNING_STORE_NAMES.CONTENTS)
            const request = objectStore.getAll()

            request.onsuccess = (event) => {
                const contents = event.target.result
                resolve(contents)
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            try {
                const statement = db.prepareSync(`SELECT * FROM ${LEARNING_STORE_NAMES.CONTENTS}`)
                const contents = statement.getAllSync()
                statement.finalizeSync()

                const modifiedContents = contents.map((content) => {
                    return {
                        ...content,
                        status: parseInt(content.status),
                        evaluations: JSON.parse(content.evaluations || '[]'),
                        media_slides: JSON.parse(content.media_slides || '[]'),
                    }
                })

                resolve(modifiedContents)
            } catch (error) {
                console.error('Error in get_contents:', error)
                reject(error)
            }
        }
    })
}

// Evaluations implementation
export const add_evaluation = (db, evaluation) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const transaction = db.transaction([LEARNING_STORE_NAMES.EVALUATIONS], 'readwrite')
            const objectStore = transaction.objectStore(LEARNING_STORE_NAMES.EVALUATIONS)

            const request = objectStore.add(evaluation)

            request.onsuccess = () => {
                resolve()
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            try {
                // Check if evaluation exists
                const checkStatement = db.prepareSync(`SELECT COUNT(*) as count FROM ${LEARNING_STORE_NAMES.EVALUATIONS} WHERE _id = ?`)
                const first = checkStatement.getFirstSync([evaluation._id])
                const count = first?.count ?? 0
                checkStatement.finalizeSync()

                if (count === 0) {
                    // Insert new evaluation
                    const insertStatement = db.prepareSync(`INSERT INTO ${LEARNING_STORE_NAMES.EVALUATIONS} (
                        _id, name, can_repeat, can_repeat_failure, can_repeat_success, type_assessment,
                        questions, count_questions, questions_random, assessmentResult, survey, approval_rate
                    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`)

                    insertStatement.executeSync([
                        evaluation._id,
                        evaluation.name,
                        evaluation.can_repeat,
                        evaluation.can_repeat_failure,
                        evaluation.can_repeat_success,
                        JSON.stringify(evaluation.type_assessment || []),
                        JSON.stringify(evaluation.questions || []),
                        evaluation.count_questions,
                        // Map both possible sources: "random" or "questions_random"
                        typeof evaluation.questions_random !== 'undefined' ? evaluation.questions_random : evaluation.random,
                        evaluation.assessmentResult,
                        JSON.stringify(evaluation.survey || []),
                        evaluation.approval_rate,
                    ])

                    insertStatement.finalizeSync()
                }

                resolve()
            } catch (error) {
                console.error('Error in add_evaluation:', error)
                reject(error)
            }
        }
    })
}

export const get_evaluations = (db) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const transaction = db.transaction([LEARNING_STORE_NAMES.EVALUATIONS], 'readonly')
            const objectStore = transaction.objectStore(LEARNING_STORE_NAMES.EVALUATIONS)
            const request = objectStore.getAll()

            request.onsuccess = (event) => {
                const evaluations = event.target.result
                resolve(evaluations)
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            try {
                const statement = db.prepareSync(`SELECT * FROM ${LEARNING_STORE_NAMES.EVALUATIONS}`)
                const evaluations = statement.getAllSync()
                statement.finalizeSync()

                const modifiedEvaluations = evaluations.map((evaluation) => {
                    return {
                        ...evaluation,
                        type_assessment: deepJSONParse(evaluation.type_assessment) || [],
                        questions: deepJSONParse(evaluation.questions) || [],
                        survey: deepJSONParse(evaluation.survey) || [],
                    }
                })

                resolve(modifiedEvaluations)
            } catch (error) {
                console.error('Error in get_evaluations:', error)
                reject(error)
            }
        }
    })
}

// Placeholder functions for now - will implement if needed
export const add_category = (db, category) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            try {
                const transaction = db.transaction([LEARNING_STORE_NAMES.CATEGORIES], 'readwrite')
                const objectStore = transaction.objectStore(LEARNING_STORE_NAMES.CATEGORIES)
                const request = objectStore.add({
                    _id: category._id,
                    category_name: category.category_name,
                    description: category.description,
                    cover_image: category.cover_image,
                    channel_icon: category.channel_icon,
                    action: category.action,
                    blocked_by: category.blocked_by,
                    repository: category.repository,
                    category_home: category.category_home,
                    status: category.status,
                    category_index: category.index ?? category.category_index ?? 0,
                })

                request.onsuccess = () => resolve()
                request.onerror = (event) => reject(event.target.error)
            } catch (error) {
                reject(error)
            }
        } else {
            try {
                // Check if category exists
                const checkStatement = db.prepareSync(`SELECT COUNT(*) as count FROM ${LEARNING_STORE_NAMES.CATEGORIES} WHERE _id = ?`)
                const first = checkStatement.getFirstSync([category._id])
                const count = first?.count ?? 0
                checkStatement.finalizeSync()

                if (count === 0) {
                    const insertStatement = db.prepareSync(`INSERT INTO ${LEARNING_STORE_NAMES.CATEGORIES} (
                        _id, category_name, description, cover_image, channel_icon, action, blocked_by,
                        repository, category_home, status, category_index
                    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`)

                    insertStatement.executeSync([
                        category._id,
                        category.category_name,
                        category.description,
                        category.cover_image,
                        category.channel_icon,
                        JSON.stringify(category.action || null),
                        JSON.stringify(category.blocked_by || []),
                        JSON.stringify(category.repository || []),
                        JSON.stringify(category.category_home ?? null),
                        category.status,
                        category.index ?? category.category_index ?? 0,
                    ])

                    insertStatement.finalizeSync()
                }
                resolve()
            } catch (error) {
                console.error('Error in add_category:', error)
                reject(error)
            }
        }
    })
}

export const get_categories = (db) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            try {
                const transaction = db.transaction([LEARNING_STORE_NAMES.CATEGORIES], 'readonly')
                const objectStore = transaction.objectStore(LEARNING_STORE_NAMES.CATEGORIES)
                const request = objectStore.getAll()

                request.onsuccess = (event) => resolve(event.target.result)
                request.onerror = (event) => reject(event.target.error)
            } catch (error) {
                reject(error)
            }
        } else {
            try {
                const statement = db.prepareSync(`SELECT * FROM ${LEARNING_STORE_NAMES.CATEGORIES}`)
                const categories = statement.getAllSync()
                statement.finalizeSync()

                const modified = categories.map((c) => ({
                    ...c,
                    blocked_by: JSON.parse(c.blocked_by || '[]'),
                    repository: JSON.parse(c.repository || '[]'),
                    category_home: JSON.parse(c.category_home || 'null'),
                    status: parseInt(c.status),
                    index: c.category_index ?? c.index ?? 0,
                }))
                // console.log(
                //     '[DEBUG K] Categorias recuperadas y mapeadas:',
                //     modified.filter((cat) => cat._id == '24'),
                // )
                resolve(modified)
            } catch (error) {
                console.error('Error in get_categories:', error)
                reject(error)
            }
        }
    })
}

// reconstructData function to organize learning data
export const reconstructData = (categories, courses, contents, evaluations) => {
    try {
        // Estructura esperada por la UI móvil: cada categoría debe tener `repository` (lista de cursos)
        const categoriesWithRepository = categories.map((category) => ({
            ...category,
            repository: courses
                .filter((course) => category.repository.includes(course._id))
                .map((course) => {
                    const courseEvaluations = deepJSONParse(course.evaluations)
                    const evaluationIds = Array.isArray(courseEvaluations) ? courseEvaluations : []

                    return {
                        ...course,
                        contents: contents.filter((content) => content.course_id === course._id),
                        evaluations: evaluations.filter((evaluation) => evaluationIds.includes(evaluation._id)),
                    }
                }),
        }))

        return categoriesWithRepository
    } catch (error) {
        console.error('Error in reconstructData:', error)
        return []
    }
}

// --- Compatibility stubs and aliases to satisfy existing imports in UI code ---
// IDs helpers
export const get_course_by_id = async (db, id) => {
    const courses = await get_courses(db)
    const course = courses.find((c) => c._id === id)

    if (!course) {
        // Course not found
        return null
    }

    // Course found

    // Reconstruct moduls with full content data
    if (course.moduls && Array.isArray(course.moduls) && course.moduls.length > 0) {
        const contents = await get_contents(db)

        // Map module IDs to full content objects
        course.moduls = course.moduls
            .map((moduleId) => {
                // If moduleId is already an object, return it
                if (typeof moduleId === 'object' && moduleId !== null) {
                    return moduleId
                }

                // Otherwise, find the content by ID
                const content = contents.find((c) => c._id === moduleId)
                // if not found, keep id stub
                return content || { _id: moduleId } // Return at least the ID if content not found
            })
            .filter((module) => module !== null) // Filter out null values
    }

    return course
}

export const get_evaluation_by_id = async (db, id) => {
    const evaluations = await get_evaluations(db)
    return evaluations.find((e) => e._id === id) || null
}

export const get_category_by_id = async (db, id) => {
    const categories = await get_categories(db)
    return categories.find((c) => c._id === id) || null
}

// course/content status updates (no-op stubs for now)
// Actualiza el estado de un curso (si fuera necesario). Mantener firma flexible.
export const update_status_local_course = async (dbParam, courseId, newStatus) => {
    try {
        const db = dbParam || (await openDB())
        if (typeof courseId === 'undefined' || typeof newStatus === 'undefined') return true
        if (isWeb()) {
            const tx = db.transaction([LEARNING_STORE_NAMES.COURSES], 'readwrite')
            const store = tx.objectStore(LEARNING_STORE_NAMES.COURSES)
            const req = store.get(courseId)
            await new Promise((res, rej) => {
                req.onsuccess = () => res()
                req.onerror = (e) => rej(e)
            })
            const course = req.result
            if (course) {
                course.status = newStatus
                const putReq = store.put(course)
                await new Promise((res, rej) => {
                    putReq.onsuccess = () => res()
                    putReq.onerror = (e) => rej(e)
                })
            }
            return true
        } else {
            try {
                const stmt = db.prepareSync(`UPDATE ${LEARNING_STORE_NAMES.COURSES} SET status = ? WHERE _id = ?`)
                stmt.executeSync([newStatus, courseId])
                stmt.finalizeSync()
                return true
            } catch (error) {
                console.error('Error in update_status_local_course:', error)
                return false
            }
        }
    } catch (error) {
        console.error('Error in update_status_local_course:', error)
        return false
    }
}

export const update_status_local_category = async () => {
    return true
}

// Actualiza un curso puntual con nuevo status (alias histórico)
export const update_course_local = async (dbParam, courseId, newStatus) => {
    return update_status_local_course(dbParam, courseId, newStatus)
}

// Actualiza estados de contenidos (módulos). Recibe payload: [{ module, status }]
export const update_status_local_content = async (payload) => {
    try {
        if (!Array.isArray(payload) || payload.length === 0) return true
        const db = await openDB()
        if (isWeb()) {
            const tx = db.transaction([LEARNING_STORE_NAMES.CONTENTS], 'readwrite')
            const store = tx.objectStore(LEARNING_STORE_NAMES.CONTENTS)
            for (const item of payload) {
                try {
                    const id = item?.module?._id || item?._id || item?.moduleId
                    const status = item?.status
                    if (typeof id === 'undefined' || typeof status === 'undefined') continue
                    const getReq = store.get(id)
                    await new Promise((res, rej) => {
                        getReq.onsuccess = () => res()
                        getReq.onerror = (e) => rej(e)
                    })
                    const content = getReq.result
                    if (content) {
                        content.status = status
                        const putReq = store.put(content)
                        await new Promise((res, rej) => {
                            putReq.onsuccess = () => res()
                            putReq.onerror = (e) => rej(e)
                        })
                    }
                } catch (e) {
                    console.error('update_status_local_content (web) item error:', e)
                }
            }
            return true
        } else {
            try {
                const stmt = db.prepareSync(`UPDATE ${LEARNING_STORE_NAMES.CONTENTS} SET status = ? WHERE _id = ?`)
                for (const item of payload) {
                    try {
                        const id = item?.module?._id || item?._id || item?.moduleId
                        const status = item?.status
                        if (typeof id === 'undefined' || typeof status === 'undefined') continue
                        stmt.executeSync([status, id])
                    } catch (e) {
                        console.error('update_status_local_content (native) item error:', e)
                    }
                }
                stmt.finalizeSync()
                return true
            } catch (error) {
                console.error('Error in update_status_local_content (native):', error)
                return false
            }
        }
    } catch (error) {
        console.error('Error in update_status_local_content:', error)
        return false
    }
}

// certificates stubs
export const update_course_certificate = async (db, course_id, certificate) => {
    const table = LEARNING_STORE_NAMES.COURSES

    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const tx = db.transaction([table], 'readwrite')
            const store = tx.objectStore(table)

            const getReq = store.get(course_id)

            getReq.onsuccess = (e) => {
                const course = e.target.result

                if (!course) {
                    console.log('⚠️ course not found')
                    return resolve()
                }

                course.certificate = certificate

                const putReq = store.put(course)

                putReq.onsuccess = () => resolve()
                putReq.onerror = (e) => reject(e.target.error)
            }

            getReq.onerror = (e) => reject(e.target.error)
            return
        }

        // 📱 MOBILE (SQLite) ------------------------------
        try {
            // 1️⃣ Buscar si existe
            const row = db.getFirstSync(`SELECT COUNT(*) AS count FROM ${table} WHERE _id = ?`, [course_id])

            const exists = row?.count > 0

            if (!exists) {
                console.log('⚠️ update_course_certificate: course not found')
                return resolve()
            }

            // 2️⃣ Actualizar el campo certificate
            const statement = db.prepareSync(
                `UPDATE ${table} 
                 SET certificate = ? 
                 WHERE _id = ?`,
            )

            statement.executeSync([certificate, course_id])
            statement.finalizeSync()

            resolve()
        } catch (error) {
            console.error('❌ update_course_certificate mobile error:', error)
            reject(error)
        }
    })
}

export const update_content_certificate = async (db, content_id, certificate) => {
    const table = LEARNING_STORE_NAMES.CONTENTS

    return new Promise((resolve, reject) => {
        if (isWeb()) {
            // 🌐 WEB ------------------------------------
            const tx = db.transaction([table], 'readwrite')
            const store = tx.objectStore(table)

            const getReq = store.get(content_id)

            getReq.onsuccess = (e) => {
                const content = e.target.result

                if (!content) {
                    console.log('⚠️ content not found')
                    return resolve()
                }

                content.certificate = certificate

                const putReq = store.put(content)

                putReq.onsuccess = () => resolve()
                putReq.onerror = (e) => reject(e.target.error)
            }

            getReq.onerror = (e) => reject(e.target.error)
            return
        }

        // 📱 MOBILE ------------------------------------
        try {
            // 1️⃣ Verificar si existe
            const row = db.getFirstSync(`SELECT COUNT(*) AS count FROM ${table} WHERE _id = ?`, [content_id])

            const exists = row?.count > 0

            if (!exists) {
                console.log('⚠️ update_content_certificate: content not found')
                return resolve()
            }

            // 2️⃣ Actualizar
            const statement = db.prepareSync(
                `UPDATE ${table}
                 SET certificate = ?
                 WHERE _id = ?`,
            )

            statement.executeSync([certificate, content_id])
            statement.finalizeSync()

            resolve()
        } catch (error) {
            console.error('❌ update_content_certificate mobile error:', error)
            reject(error)
        }
    })
}

// assessments/surveys stubs
export const save_assessment_local = (db, assessment) => {
    return new Promise((resolve, reject) => {
        const table = LEARNING_STORE_NAMES.ANSWERS_EVALUATIONS

        if (isWeb()) {
            return resolve(true)
        }

        try {
            // ------------------------------
            // 1) VALIDACIONES BÁSICAS
            // ------------------------------
            if (!assessment || typeof assessment !== 'object') {
                return reject(new Error('Invalid assessment object'))
            }

            if (!assessment._id) {
                return reject(new Error('Assessment must have _id'))
            }

            if (!assessment.evaluation_id) {
                return reject(new Error('Assessment missing evaluation_id'))
            }

            if (!assessment.course_id) {
                return reject(new Error('Assessment missing course_id'))
            }

            // Asegurar que answers es JSON válido
            const answersJson = JSON.stringify(assessment.answers ?? {})

            // ------------------------------
            // 2) CHECK SI YA EXISTE
            // ------------------------------
            const checkStmt = db.prepareSync(`SELECT COUNT(*) AS count FROM ${table} WHERE _id = ?`)

            const row = checkStmt.getFirstSync([assessment._id])
            const exists = row?.count > 0

            checkStmt.finalizeSync()

            // ------------------------------
            // 3) SI YA EXISTE → UPDATE
            // ------------------------------
            if (exists) {
                const updateStmt = db.prepareSync(
                    `UPDATE ${table}
                     SET evaluation_id = ?, 
                         course_id = ?, 
                         content_id = ?, 
                         answers = ?
                     WHERE _id = ?`,
                )

                updateStmt.executeSync([
                    String(assessment.evaluation_id),
                    String(assessment.course_id),
                    assessment.content_id ? String(assessment.content_id) : '',
                    answersJson,
                    String(assessment._id),
                ])

                updateStmt.finalizeSync()
                return resolve(true)
            }

            // ------------------------------
            // 4) SI NO EXISTE → INSERT
            // ------------------------------
            const insertStmt = db.prepareSync(
                `INSERT INTO ${table} (
                    _id,
                    evaluation_id,
                    course_id,
                    content_id,
                    answers
                ) VALUES (?, ?, ?, ?, ?)`,
            )

            insertStmt.executeSync([
                String(assessment._id),
                String(assessment.evaluation_id),
                String(assessment.course_id),
                assessment.content_id ? String(assessment.content_id) : '',
                answersJson,
            ])

            insertStmt.finalizeSync()

            resolve(true)
        } catch (error) {
            console.error('❌ Error in save_assessment_local:', error)
            reject(error)
        }
    })
}

export const save_survey_local = async (db, survey) => {
    const table = LEARNING_STORE_NAMES.ANSWERS_SURVEY

    // Normalizar answers
    const answersValue = typeof survey.answers === 'string' ? survey.answers : JSON.stringify(survey.answers || {})

    return new Promise((resolve, reject) => {
        if (isWeb()) {
            // 🌐 WEB ------------------------------------
            try {
                const tx = db.transaction([table], 'readwrite')
                const store = tx.objectStore(table)

                const request = store.add({
                    ...survey,
                    answers: answersValue,
                })

                request.onsuccess = () => resolve()
                request.onerror = (e) => reject(e.target.error)
            } catch (error) {
                console.error('❌ save_survey_local web error:', error)
                reject(error)
            }

            return
        }

        // 📱 MOBILE ------------------------------------
        try {
            // 1️⃣ Verificar si existe
            const row = db.getFirstSync(`SELECT COUNT(*) AS count FROM ${table} WHERE _id = ?`, [survey._id])

            const exists = row?.count > 0

            if (exists) {
                // Ya existe la encuesta → simplemente resolvemos
                return resolve()
            }

            // 2️⃣ Construir INSERT dinámico
            let query = null
            let params = null

            if (survey.post_id) {
                query = `
                    INSERT INTO ${table} (
                        _id,
                        post_id,
                        answers
                    ) VALUES (?, ?, ?)
                `
                params = [survey._id, survey.post_id, answersValue]
            } else if (survey.course_id) {
                query = `
                    INSERT INTO ${table} (
                        _id,
                        course_id,
                        answers
                    ) VALUES (?, ?, ?)
                `
                params = [survey._id, survey.course_id, answersValue]
            } else {
                console.error('❌ save_survey_local ERROR: survey sin post_id ni course_id')
                return reject('Survey must contain post_id or course_id')
            }

            // 3️⃣ Ejecutar INSERT
            const statement = db.prepareSync(query)
            statement.executeSync(params)
            statement.finalizeSync()

            resolve()
        } catch (error) {
            console.error('❌ save_survey_local mobile error:', error)
            reject(error)
        }
    })
}

export const get_all_assessments = async (db) => {
    const assessmentStoreName = LEARNING_STORE_NAMES.ANSWERS_EVALUATIONS

    if (isWeb()) {
        const transaction = db.transaction([assessmentStoreName], 'readonly')
        const objectStore = transaction.objectStore(assessmentStoreName)

        const request = objectStore.getAll()

        return new Promise((resolve, reject) => {
            request.onsuccess = (event) => {
                const items = event.target.result
                resolve(
                    items.map((evaluation) => ({
                        ...evaluation,
                        answers: safeParseAnswers(evaluation.answers),
                    })),
                )
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        })
    }

    // 📱 MOBILE (SQLite con execAsync)
    try {
        const result = await db.getAllSync(`SELECT * FROM ${assessmentStoreName};`)

        const modified = result.map((evaluation) => ({
            ...evaluation,
            answers: safeParseAnswers(evaluation.answers),
        }))

        return modified
    } catch (error) {
        console.error('Transaction get_all_assessments error:', error)
        throw error
    }
}

export const get_all_surveys = (db) => {
    return new Promise((resolve, reject) => {
        const surveyStoreName = LEARNING_STORE_NAMES.ANSWERS_SURVEY

        if (Platform.OS === 'web') {
            const transaction = db.transaction([surveyStoreName], 'readonly')
            const objectStore = transaction.objectStore(surveyStoreName)
            const request = objectStore.getAll()

            request.onsuccess = (event) => {
                const surveys = event.target.result
                resolve(surveys)
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            db.transaction(
                (tx) => {
                    tx.executeSql(
                        `SELECT * FROM ${surveyStoreName}`,
                        [],
                        (_, result) => {
                            const surveys = []

                            for (let i = 0; i < result.rows.length; i++) {
                                const row = result.rows.item(i)

                                // --- Normalizar la columna answers ---
                                let parsedAnswers = row.answers
                                if (typeof parsedAnswers === 'string') {
                                    try {
                                        parsedAnswers = JSON.parse(parsedAnswers)
                                    } catch (e) {
                                        console.warn(`Warning: answers no es JSON válido en survey ${row._id}`)
                                    }
                                }

                                surveys.push({
                                    ...row,
                                    answers: parsedAnswers,
                                })
                            }

                            resolve(surveys)
                        },
                        (_, error) => {
                            console.error('Error en la transacción:', error)
                            reject(error)
                        },
                    )
                },
                (error) => {
                    console.error('Error en la transacción para obtener todas las encuestas:', error)
                    reject(error)
                },
            )
        }
    })
}

export const delete_assessment_from_local_database = async (db, assessmentId) => {
    const assessmentStoreName = LEARNING_STORE_NAMES.ANSWERS_EVALUATIONS

    if (isWeb()) {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([assessmentStoreName], 'readwrite')
            const objectStore = transaction.objectStore(assessmentStoreName)

            const request = objectStore.delete(assessmentId)

            request.onsuccess = () => resolve()
            request.onerror = (event) => reject(event.target.error)
        })
    }

    try {
        await db.execAsync(`DELETE FROM ${assessmentStoreName} WHERE _id = ?;`, [assessmentId])

        return // success
    } catch (error) {
        console.error('Error deleting assessment from SQLite:', error)
        throw error
    }
}

// training progress stubs
export const save_progress_training_local = async (db, progress_course) => {
    const table = LEARNING_STORE_NAMES.SAVE_PROGRESS_TRAINING

    try {
        // ===============================
        // WEB (IndexedDB)
        // ===============================
        if (isWeb()) {
            const tx = db.transaction([table], 'readwrite')
            const store = tx.objectStore(table)

            const request = store.put(progress_course)

            return await new Promise((resolve, reject) => {
                request.onsuccess = () => resolve()
                request.onerror = (e) => reject(e.target.error)
            })
        }

        // ===============================
        // MOBILE (SQLite)
        // ===============================

        // 1) Verificamos existencia
        const checkQuery = `SELECT COUNT(*) as total FROM ${table} WHERE _id = ?;`
        const checkResult = await execAsync(db, checkQuery, [progress_course._id])

        const exists = checkResult.rows.length > 0 ? checkResult.rows.item(0).total : 0

        if (exists === 0) {
            // 2) INSERT
            const insertQuery = `
                INSERT INTO ${table} (_id, status, moduls)
                VALUES (?, ?, ?);
            `

            await execAsync(db, insertQuery, [
                progress_course._id,
                progress_course.status,
                progress_course.moduls, // YA viene stringify, no tocar
            ])

            return
        }

        // 3) UPDATE
        const updateQuery = `
            UPDATE ${table}
            SET status = ?, moduls = ?
            WHERE _id = ?;
        `

        await execAsync(db, updateQuery, [
            progress_course.status,
            progress_course.moduls, // YA viene stringify
            progress_course._id,
        ])

        return
    } catch (err) {
        console.log('save_progress_training_local error => ', err)
        throw err
    }
}

export const get_progress_training_local = (db) => {
    return new Promise((resolve, reject) => {
        const table = LEARNING_STORE_NAMES.SAVE_PROGRESS_TRAINING

        if (isWeb()) {
            // -------------------------------
            // 👉 Web (IndexedDB)
            // -------------------------------
            try {
                const transaction = db.transaction([table], 'readonly')
                const objectStore = transaction.objectStore(table)

                const request = objectStore.getAll()

                request.onsuccess = (event) => {
                    resolve(event.target.result || [])
                }

                request.onerror = (event) => {
                    reject(event.target.error)
                }
            } catch (error) {
                console.error('[get_progress_training_local] Web error:', error)
                reject(error)
            }
        } else {
            // -------------------------------
            // 👉 Mobile (SQLite SDK 54)
            // -------------------------------
            try {
                const statement = db.prepareSync(`SELECT * FROM ${table}`)

                const rows = statement.getAllSync() // ← trae todos los registros de una
                statement.finalizeSync()

                // Normalizamos a array (ya es un array de objetos)
                resolve(rows || [])
            } catch (error) {
                console.error('[get_progress_training_local] SQLite error:', error)
                reject(error)
            }
        }
    })
}

export const delete_progress_training_local = async (db, courseId) => {
    const table = LEARNING_STORE_NAMES.SAVE_PROGRESS_TRAINING

    try {
        // ===============================
        // WEB (IndexedDB)
        // ===============================
        if (isWeb()) {
            const tx = db.transaction([table], 'readwrite')
            const store = tx.objectStore(table)

            const request = store.delete(courseId)

            return await new Promise((resolve, reject) => {
                request.onsuccess = () => resolve()
                request.onerror = (e) => reject(e.target.error)
            })
        }

        // ===============================
        // MOBILE (SQLite)
        // ===============================
        const query = `DELETE FROM ${table} WHERE _id = ?;`

        await execAsync(db, query, [courseId])

        return
    } catch (err) {
        console.log('delete_progress_training_local error => ', err)
        throw err
    }
}

const safeParseAnswers = (value) => {
    if (!value) return {} // null, undefined, '' → objeto vacío

    // Si ya viene como objeto → lo devolvés así
    if (typeof value === 'object') return value

    // Si viene como string, intentás parsearlo
    if (typeof value === 'string') {
        try {
            return JSON.parse(value)
        } catch (err) {
            console.warn('Invalid JSON in answers:', value)
            return {}
        }
    }

    // Si viene cualquier otra cosa rara → devuelvo {}
    return {}
}
